export default __webpack_public_path__ + "static/media/new-logowhite.f959f320.png";